<template>
  <transition name="fade">
    <div class="introPopWrap" v-if="showIt">
      <div class="closeIcon" @click="changeShow">
        <img :src="closeIcon"/>
      </div>
      <div class="introPop">
        <img :src="personalInfo[man].img" class="img"/>
        <div class="txtWrap">
          <h6>{{personalInfo[man].manTitle}}</h6>
          <div class="theTxt" v-html="personalInfo[man].manTxt"></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import closeIcon from '@/assets/img/closeIcon.png'
import { personalInfo } from './data'

export default {
  name: 'introPop',
  props: {
    man: { // 展示哪位作家的信息
      type: String,
      default: 'beiZhai',
    },
    showIt: {
      type: Boolean,
      detault: false,
    }
  },
  data () {
    return {
      personalInfo,
      closeIcon,
    }
  },

  methods: {
    changeShow () {
      this.$emit('changeShow')
    },
  }
}
</script>

<style lang="stylus" scoped>
@import '../../stylus/app.styl'
@import '../../stylus/animation.styl'
@import './introPop.styl'
</style>